import { addingSMSAutomationFlag } from '../../redux/slices/automation';
import { brand } from '../../theme/themePrimitives';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import { updateBuildAutomationThunk } from '../../redux/thunks/automation';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, IconButton, Paper, Typography } from '@mui/material';
import { deleteNode, duplicateNode, settingSelectedNode } from '../../redux/slices/workflow';
import { DragIndicator, Phone } from '@mui/icons-material';
import { Handle, NodeProps, Position } from '@xyflow/react';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const PhoneNode: React.FC<NodeProps> = ({ data, id }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { nodes } = useSelector((state: RootState) => state.workflow);
    const [hovered, setHovered] = useState(false);

    const onDuplicateHandler = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        dispatch(duplicateNode(id));
        try {
            await dispatch(updateBuildAutomationThunk()).unwrap();
        } catch (err) {
            // Catch errors
        }
    };

    const onDeleteHandler = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        dispatch(deleteNode(id));
        try {
            await dispatch(updateBuildAutomationThunk()).unwrap();
        } catch (err) {
            // Catch errors
        }
    };

    const editHandler = () => {
        const selectedNode = nodes.find((node) => node.id === id);
        if (selectedNode) {
            dispatch(settingSelectedNode(selectedNode));
            dispatch(addingSMSAutomationFlag(true));
        }
    };

    return (
        <Paper
            elevation={2}
            sx={{
                'display': 'flex',
                'alignItems': 'center',
                'gap': 1,
                'padding': '8px 12px',
                'backgroundColor': 'white',
                'borderRadius': '12px',
                'position': 'relative',
                'minWidth': '380px',
                '&:hover .hover-toolbar': { opacity: 1, backgroundColor: '#E8F0FE' },
                '&:hover': {
                    backgroundColor: '#E8F0FE'
                }
            }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onClick={editHandler}
        >
            {/* Drag Handle */}
            <DragIndicator sx={{ color: '#888', cursor: 'grab' }} />

            {/* Email Icon */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                bgcolor={brand[100]}
                padding="6px"
                borderRadius={1}
            >
                <Phone sx={{ color: brand[300] }} />
            </Box>

            {/* Node Label */}
            <Typography variant="h6">{data.label as string || 'Action'}</Typography>

            {/* Toolbar (Shown on Hover) */}
            {hovered && (
                <Box
                    className="hover-toolbar"
                    sx={{
                        display: 'flex',
                        gap: 1,
                        position: 'absolute',
                        right: 8,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        opacity: 0,
                        transition: 'opacity 0.3s ease-in-out'
                    }}
                >
                    <IconButton size="small" sx={{ color: 'blue' }} onClick={onDuplicateHandler}>
                        <ContentCopyIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" sx={{ color: 'red' }} onClick={onDeleteHandler}>
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                </Box>
            )}

            {/* Input and Output Handles */}
            <Handle type="target" position={Position.Top} style={{ background: '#555' }} />
            <Handle type="source" position={Position.Bottom} style={{ background: '#555' }} />
        </Paper>
    );
};

export default PhoneNode;
